import { takeEvery, takeLatest, fork, put, all, call } from "redux-saga/effects";
import EncryptPassword from "../../components/EncryptPassword";

import {
  POST_ORG_USER,
  PUT_ORG_USER,
  DELETE_ORGANIZATION_USER,
  CLEAR_ALL_ORG_USER_MESSAGES,
} from "./actionTypes";

import {
  postOrgUserSuccessful,
  postOrgUserFailed,
  putOrgUserSuccessful,
  putOrgUserFailed,
  deleteOrganizationUserSuccessful,
  deleteOrganizationUserFailed,
  clearAllOrgUserMessagesSuccessful,
} from "./actions";

import {
  addOrgUser as addOrgUserApi,
  editOrgUser as editOrgUserApi,
  deleteOrgUser as deleteOrgUserApi,
} from "../../helpers/auth_helper";

function* createOrgUser( {payload: { orgUser }}) {
  try {
    orgUser.password = EncryptPassword(orgUser.password);
    console.log("Payload for Add User:: ", orgUser)
    const response = yield call(addOrgUserApi, orgUser);
    console.log("addOrgUserApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(postOrgUserSuccessful(response));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(postOrgUserFailed({ message: message }));
    }
  } catch (error) {
    console.log("addOrgUserApi Error: ", error);
    if(error.response){
      yield put(postOrgUserFailed({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(postOrgUserFailed({message: "No response is received"}))
    } else{
      yield put(postOrgUserFailed({message: error?.message}));
    }
  }
}

function* editOrgUser( {payload: { orgUser }}) {
  try {
    const response = yield call(editOrgUserApi, orgUser);
    console.log("editOrgUserApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      let responseMessage = Object.values(response).join('');
      yield put(putOrgUserSuccessful(responseMessage));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(putOrgUserFailed({ message: message }));
    }
  } catch (error) {
    console.log("editOrgUserApi Error: ", error);
    if(error.response){
      yield put(putOrgUserFailed({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(putOrgUserFailed({message: "No response is received"}))
    } else{
      yield put(putOrgUserFailed({message: error?.message}));
    }
  }
}

function* deleteOrgUser( {payload: { orgUser }}) {
  console.log("🚀 ~ deleteOrgUser ~ orgUser:", orgUser)
  try {
    const response = yield call(deleteOrgUserApi, orgUser);
    console.log("deleteOrgUserApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(deleteOrganizationUserSuccessful(response));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(deleteOrganizationUserFailed({ message: message }));
    }
  } catch (error) {
    console.log("deleteOrgUserApi Error: ", error);
    if(error.response){
      yield put(deleteOrganizationUserFailed({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(deleteOrganizationUserFailed({message: "No response is received"}))
    } else{
      yield put(deleteOrganizationUserFailed({message: error?.message}));
    }
  }
}

export function* clearAllOrgUserMessages() {
  console.log("clearAllOrgUserMessages Saga: clear all messages");
  yield put(clearAllOrgUserMessagesSuccessful());
}

function* watchOrgUsers() {
  yield takeLatest(POST_ORG_USER, createOrgUser);
  yield takeLatest(PUT_ORG_USER, editOrgUser);
  yield takeLatest(DELETE_ORGANIZATION_USER, deleteOrgUser);
  yield takeLatest(CLEAR_ALL_ORG_USER_MESSAGES, clearAllOrgUserMessages);
}

function* orgUsersSaga() {
  yield all([fork(watchOrgUsers)])
}

export default orgUsersSaga;